<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="资产码">
        <el-input placeholder="请输入资产码" v-model="filter.assets_code" clearable></el-input>
      </el-form-item>
      <el-form-item label="名称">
        <el-input placeholder="请输入名称" v-model="filter.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="是否投运">
        <el-select class="selScale" v-model="filter.is_operation">
          <el-option label="--全部--" value=""> </el-option>
          <el-option label="是" value="true"> </el-option>
          <el-option label="否" value="false"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button icon="el-icon-plus" type="success" @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button>
        <el-button icon="el-icon-upload" type="warning" @click="onTongbuKc" v-permision_tjtf="'tongbu_kc'">同步库存</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
      <el-table-column label="分支箱名" prop="name" align="center"></el-table-column>
      <el-table-column label="是否投运" prop="status_name" align="center" width="100">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.is_operation">是</el-tag>
          <el-tag type="info" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="所属一体柜" prop="cabinet_name" align="center"></el-table-column>
      <el-table-column label="资产码" prop="assets_code" width="220" align="center">
        <template slot-scope="{ row }">
          <div class="show_assets_code" @click="showTripletDetail(row.assets_code)">{{ row.assets_code }}</div>
        </template>
      </el-table-column>
      <el-table-column label="分支箱图片" prop="pic_json">
        <template slot-scope="{ row }">
          <el-image v-if="getFirstImageUrl(row.pic_json)" class="table-img" :src="getFirstImageUrl(row.pic_json)" fit="cover" :preview-src-list="getAllImageUrls(row.pic_json)"> </el-image>
          <span v-else>无图片</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time" align="center"></el-table-column>
      <el-table-column label="修改时间" prop="modify_time" align="center"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="280px" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onUpdate(row)" v-permision_tjtf="'edit'">编辑</el-button>
          <el-button type="text" @click="editChargingConfig(row)" v-permision_tjtf="'model'">计费模型</el-button>
          <el-button type="text" @click="feeTable(row)" v-permision_tjtf="'control_table'">费控表</el-button>
          <el-button type="text" @click="onConfig(row)" v-permision_tjtf="'‌configure'">配置</el-button>
          <el-button type="text" @click="onDelete(row)" v-permision_tjtf="'delete'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 新增or修改分支箱 -->
    <el-dialog :visible.sync="visible.editGroup" :title="isUpdate ? $t('groupmanage.editortitle') : $t('groupmanage.appendtitle')" width="1000px">
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form label-position="right" label-width="100px" :model="form" :rules="formRules" ref="groupForm">
            <el-form-item label="分支箱名" prop="name" label-width="20%">
              <el-input placeholder="请输入分支箱名" v-model="form.name" maxlength="30" show-word-limit />
            </el-form-item>
            <el-form-item label="三元组" prop="assets_code" label-width="20%">
              <div @click="onSelectTriplet">
                <el-input :disabled="isUpdate" v-model="form.assets_code" readonly placeholder="请选择三元组" suffix-icon="el-icon-more"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="所属一体柜" prop="power_cabinet_id" label-width="20%">
              <el-select v-model="form.power_cabinet_id" placeholder="请选择所属一体柜" style="width: 100%" clearable filterable @change="handleCabinetChange">
                <el-option v-for="item in cabinetOptions" :key="item.ID" :label="item.name" :value="item.ID">
                  <span style="float: left">{{ item.name || "无名称" }}</span>
                  <!-- <span style="float: right; color: #8492a6; font-size: 13px"> 地址: {{ item.address }} </span> -->
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="地址" prop="address" label-width="20%">
              <el-input placeholder="请输入地址" v-model="form.address" />
            </el-form-item>
            <el-form-item label="是否投运" label-width="20%">
              <el-switch v-model="form.is_operation" active-text="是" inactive-text="否" />
            </el-form-item>
            <el-form-item label="分支箱图片" prop="pic_json" label-width="20%">
              <file-upload listType="picture-card" :limit="100" @fileChange="fileChange" field="pic_json" :fileList="form.pic_json"></file-upload>
            </el-form-item>
            <el-form-item label="备注" prop="remark" label-width="20%">
              <el-input placeholder="请输入备注" v-model="form.remark" />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="visible.editGroup = false">{{ $t("groupmanage.cancelbtn") }}</el-button>
        <el-button type="primary" @click="onSubmit">{{ $t("groupmanage.confirmbtn") }}</el-button>
      </span>
    </el-dialog>

    <!-- 三元组选择框 -->
    <select-triplet :show.sync="visible.triplet" @confirm="confirmSelectTriplet" :device-type="form.typename"></select-triplet>
    <!-- 配置电柜对话框 -->
    <el-dialog :visible.sync="visible.configDialog" title="配置更新" width="600px">
      <el-row type="flex" justify="center" class="lower_formitem_box">
        <el-col :span="22">
          <el-form label-position="right" label-width="200px" :model="configForm" :rules="configRules" ref="configForm">
            <!-- 终端上报频率（实时监测上报频率） -->
            <el-form-item label="终端上报频率(秒)：" prop="triphase_freq" required>
              <el-input-number v-model="configForm.triphase_freq" :min="1" :max="86400" :step="1" :precision="0" placeholder="请输入终端上报频率" style="width: 200px" />
            </el-form-item>

            <!-- 负荷开关属性上报频率 -->
            <el-form-item label="负荷开关属性上报频率(秒)：" prop="breaker_freq" required>
              <el-input-number v-model="configForm.breaker_freq" :min="1" :max="86400" :step="1" :precision="0" placeholder="请输入负荷开关属性上报频率" style="width: 200px" />
            </el-form-item>

            <!-- A相负荷容量 -->
            <el-form-item label="A相负荷容量(kWA)：" prop="trans_acap" required>
              <el-input-number v-model="configForm.trans_acap" :min="0" :max="10000" :step="1" :precision="0" placeholder="请输入A相负荷容量" style="width: 200px" />
            </el-form-item>

            <!-- B相负荷容量 -->
            <el-form-item label="B相负荷容量(kWA)：" prop="trans_bcap" required>
              <el-input-number v-model="configForm.trans_bcap" :min="0" :max="10000" :step="1" :precision="0" placeholder="请输入B相负荷容量" style="width: 200px" />
            </el-form-item>

            <!-- C相负荷容量 -->
            <el-form-item label="C相负荷容量(kWA)：" prop="trans_ccap" required>
              <el-input-number v-model="configForm.trans_ccap" :min="0" :max="10000" :step="1" :precision="0" placeholder="请输入C相负荷容量" style="width: 200px" />
            </el-form-item>
            <!-- 负荷开关个数 -->
            <el-form-item label="负荷开关个数" prop="breaker_num" required>
              <el-select v-model="configForm.breaker_num">
                <el-option v-for="item in breakerNums" :label="item.label" :value="item.Id" :key="item.Id"></el-option>
              </el-select>
            </el-form-item>
            <!-- 温度跳闸开关： -->
            <el-form-item label="温度跳闸开关：" prop="temp_trip_off" required>
              <el-radio-group v-model="configForm.temp_trip_off">
                <el-radio :label="0">开启</el-radio>
                <el-radio :label="1">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 本地调控开关： -->
            <el-form-item label="本地调控开关：" prop="local_strate_off" required>
              <el-radio-group v-model="configForm.local_strate_off">
                <el-radio :label="0">开启</el-radio>
                <el-radio :label="1">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 设备组网网关： -->
            <el-form-item label="设备组网网关："> {{ configForm.mac_gate }} </el-form-item>

            <!-- 费控表组网地址： -->
            <el-form-item label="一体柜网络地址："> {{ configForm.lora_mac_str }} </el-form-item>

            <el-row type="flex" justify="left" class="custom-label">
              <el-col :span="9">
                <!-- 负荷开关A -->
                <el-form-item label="开关1" prop="breaker_a" required>
                  <el-select v-model="configForm.breaker_a">
                    <el-option v-for="item in breakerParams" :label="item.label" :value="item.Id" :key="item.Id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="2"><label class="x_lab">A相</label> </el-col>
              <el-col :span="4" class="temp-label">
                <el-form-item label="温度阈值" prop="temp_a" required>
                  <el-input type="number" v-model="configForm.temp_a" placeholder="温度阈值" style="width: 120px" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="left" class="custom-label">
              <el-col :span="9">
                <!-- 负荷开关B -->
                <el-form-item label="开关2" prop="breaker_b" required>
                  <el-select v-model="configForm.breaker_b">
                    <el-option v-for="item in breakerParams" :label="item.label" :value="item.Id" :key="item.Id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <label class="x_lab">B相</label>
              </el-col>
              <el-col :span="4" class="temp-label">
                <el-form-item label="温度阈值" prop="temp_b" required>
                  <el-input type="number" v-model="configForm.temp_b" placeholder="温度阈值" style="width: 120px" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="left" class="custom-label">
              <el-col :span="9">
                <!-- 负荷开关C -->
                <el-form-item label="开关3" prop="breaker_c" required>
                  <el-select v-model="configForm.breaker_c">
                    <el-option v-for="item in breakerParams" :label="item.label" :value="item.Id" :key="item.id+'_breakerParams'"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <label class="x_lab">C相</label>
              </el-col>
              <el-col :span="4" class="temp-label">
                <el-form-item label="温度阈值" prop="temp_c" required>
                  <el-input type="number" v-model="configForm.temp_c" placeholder="温度阈值" style="width: 120px" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="left" class="custom-label">
              <el-col :span="9"></el-col>
              <el-col :span="2"><label class="x_lab">N相</label></el-col>
              <el-col :span="4" class="temp-label">
                <el-form-item label="温度阈值" prop="temp_n" required>
                  <el-input type="number" v-model="configForm.temp_n" placeholder="温度阈值" style="width: 120px" />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 下发结果和下发时间 -->
            <el-form-item label="下发结果：" v-if="configForm && configForm.send_log">
              <span :style="{ color: configForm.send_log.push_state == 1 ? '#67C23A' : '#F56C6C' }"> {{ configForm.send_log.push_state == 0 ? "未下发" : configForm.send_log.push_state == 1 ? "成功" : "失败" }} </span><br />
              <span :style="{ color: configForm.send_log.push_state == 1 ? '#67C23A' : '#F56C6C' }">
                {{ configForm.send_log.remark }}
              </span>
              <br />
              <span :style="{ color: configForm.send_log.push_state == 1 ? '#67C23A' : '#F56C6C' }"> 操作时间：{{ configForm.send_log.push_time }} </span>
              <br />
              <span :style="{ color: configForm.send_log.push_state == 1 ? '#67C23A' : '#F56C6C' }"> 实发时间：{{ configForm.send_log.run_time }} </span>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="visible.configDialog = false">取消</el-button>
        <el-button type="primary" @click="saveParamSubmit(1)">保存配置</el-button>
        <el-button type="success" @click="saveParamSubmit(2)">下发配置</el-button>
      </span>
    </el-dialog>
    <!-- 时间段计费模型 -->
    <charging-config :show.sync="visible.costModel" @confirm="getModelId" :params="modelParams" :type="seletType" :billingModel="billingModel"></charging-config>
    <tripletDetail ref="tripletDetail"></tripletDetail>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import selectTriplet from "./components/select-triplet.vue"
import chargingConfig from "./components/charging-config.vue"
import tripletDetail from "../control/_triplet_detail.vue"

import { getPowerBranchBoxList, modifyPowerBranchBox, delPowerBranchBox, addPowerBranchBox, getPowerCabinetList, tongbuKcBranchBox } from "@/api/dev_archive"
import { Get_BrandBox_ParamConfigById, Save_BrandBox_ParamConfig, Push_BrandBox_ParamConfig } from "@/api/dev_arch_brancdbox"

import { mapGetters } from "vuex"

export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { fileUpload, selectTriplet, chargingConfig, tripletDetail },

  data() {
    return {
      visible: {
        editGroup: false,
        triplet: false,
        costModel: false,
        configDialog: false
      },
      tableData: [],
      form: {
        name: "",
        triplet_id: "",
        assets_code: "",
        power_cabinet_id: "",
        address: "",
        remark: "",
        typename: "分支箱",
        is_operation: true,
        costModel: "", // 计费模型ID
        costModelName: "", // 计费模型名称
        pic_json: []
      },
      cabinetOptions: [], // 一体柜选项数组
      breakerParams: [
        { label: "无", Id: 0 },
        { label: "合闸", Id: 1 },
        { label: "跳闸", Id: 2 }
      ],
      breakerNums: [
        { label: "0", Id: 0 },
        { label: "1", Id: 1 },
        { label: "2", Id: 2 },
        { label: "3", Id: 3 },
        { label: "4", Id: 4 }
      ],
      formRules: {},
      filter: {
        name: "",
        assets_code: "",
        is_operation: ""
      },
      loading: false,
      isUpdate: true,
      gid: "", // 分支箱ID
      seletType: "", // 计费模型操作类型
      billingModel: "brandbox", //不同场景的计费模型
      modelParams: {}, // 计费模型参数
      configForm: {
        triphase_freq: 300, // 实时监测上报频率（终端上报频率）
        breaker_freq: 300, // 负荷开关属性上报频率
        trans_acap: 0, // A相负荷容量
        trans_bcap: 0, // B相负荷容量
        trans_ccap: 0, // C相负荷容量
        breaker_a: 0, // 负荷开关A：0-无, 1-合闸, 2-跳闸
        breaker_b: 0, // 负荷开关B：0-无, 1-合闸, 2-跳闸
        breaker_c: 0 // 负荷开关C：0-无, 1-合闸, 2-跳闸
      },
      currentCabinetId: "",
      currentCabinetName: "",
      configResult: null,
      isConfigLoading: false,

      // 配置表单验证规则
      configRules: {
        triphase_freq: [
          { required: true, message: "请输入终端上报频率", trigger: "blur" },
          { type: "number", message: "必须为数字值", trigger: "blur" },
          { validator: this.validateFrequency, trigger: "blur" }
        ],
        breaker_freq: [
          { required: true, message: "请输入负荷开关属性上报频率", trigger: "blur" },
          { type: "number", message: "必须为数字值", trigger: "blur" },
          { validator: this.validateFrequency, trigger: "blur" }
        ],
        trans_acap: [
          { required: true, message: "请输入A相负荷容量", trigger: "blur" },
          { type: "number", message: "必须为数字值", trigger: "blur" },
          { validator: this.validateCapacity, trigger: "blur" }
        ],
        trans_bcap: [
          { required: true, message: "请输入B相负荷容量", trigger: "blur" },
          { type: "number", message: "必须为数字值", trigger: "blur" },
          { validator: this.validateCapacity, trigger: "blur" }
        ],
        trans_ccap: [
          { required: true, message: "请输入C相负荷容量", trigger: "blur" },
          { type: "number", message: "必须为数字值", trigger: "blur" },
          { validator: this.validateCapacity, trigger: "blur" }
        ],

        breaker_a: [{ required: true, message: "请选择负荷开关A状态", trigger: "change" }],
        breaker_b: [{ required: true, message: "请选择负荷开关B状态", trigger: "change" }],
        breaker_c: [{ required: true, message: "请选择负荷开关C状态", trigger: "change" }],
        temp_a: [{ required: true, message: "温度阈值必填", trigger: "blur" }],
        temp_b: [{ required: true, message: "温度阈值必填", trigger: "blur" }],
        temp_c: [{ required: true, message: "温度阈值必填", trigger: "blur" }],
        temp_n: [{ required: true, message: "温度阈值必填", trigger: "blur" }]
      },
      uploadhandlerimgs: ""
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.formRules = {
      power_cabinet_id: [{ required: true, message: "请选择所属一体柜", trigger: "change" }],
      assets_code: [{ required: true, message: "请选择三元信息", trigger: "change" }],
      name: [{ required: true, message: "请输入分支箱名称", trigger: "change" }]
    }

    // 加载一体柜数据并初始化表格数据
    this.loadCabinetOptions().then(() => {
      this.getData()
    })
  },
  methods: {
    // 计费模型相关方法
    getModelId(modelId) {
      this.form.costModel = modelId
      // 这里应该根据modelId获取计费模型名称，暂时用ID代替
      this.form.costModelName = modelId
      this.getData()
    },
    showTripletDetail(assetsCode) {
      this.$refs.tripletDetail.showTripletInfo(assetsCode)
    },
    editChargingConfig(row) {
      //console.log("2322222", type)
      this.seletType = row
      this.modelParams = { charging_config_id: row.charging_config_id, power_branch_box_id: row.ID, triplet_id: row.triplet_id }
      this.visible.costModel = true
    },
    feeTable(row) {
      //this.$router.push("cost-control")
      console.log(row)
      this.$router.push({ path: "/dev_archive/fee-table", query: { lineId: row.ID, queryType: 1 } })
    },
    onCostModel(row) {
      this.visible.editGroup = true
      this.isUpdate = true
      this.gid = row.ID

      // 设置表单数据
      this.form.name = row.name
      this.form.power_cabinet_id = row.power_cabinet_id
      this.form.address = row.address
      this.form.remark = row.remark
      this.form.triplet_id = row.triplet_id
      this.form.assets_code = row.assets_code

      this.form.costModel = row.costModel || ""
      this.form.costModelName = row.costModelName || ""

      // 确保一体柜数据已加载
      if (!this.cabinetOptions.length) {
        this.loadCabinetOptions()
      }
    },

    // 加载一体柜选项
    loadCabinetOptions() {
      return getPowerCabinetList({ pagesize: 100000 }).then((res) => {
        if (res && res.data) {
          // 筛选未删除的一体柜
          this.cabinetOptions = res.data.filter((item) => !item.del)
          return this.cabinetOptions
        }
        return []
      })
    },

    // 一体柜选择变化事件
    handleCabinetChange(value) {
      if (value) {
        // 查找完整的一体柜信息
        const selectedCabinet = this.cabinetOptions.find((item) => item.ID === value)
        if (selectedCabinet) {
        } else {
        }
      }
      console.groupEnd()
    },
    async saveParamSubmit(type) {
      // 验证表单
      this.$refs.configForm.validate(async (valid) => {
        if (!valid) {
          this.$message.warning("请检查表单填写是否正确")
          return
        }
        const loading = this.$loading({
          lock: true,
          text: "正在保存配置...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        })
        const saveData = {
          bmi_power_cabinet_id: this.currentCabinetId,
          ...this.configForm
        }
        let result = null
        if (type == 1) {
          result = await Save_BrandBox_ParamConfig(saveData)
        } else {
          result = await Push_BrandBox_ParamConfig(saveData)
        }
        loading.close()
        if (result && result.status) {
          this.$message.success(result.msg)
          this.visible.configDialog = false
          // 清除之前的下发结果
          this.configResult = null
        } else {
          this.$message.error(result?.msg || "配置保存失败")
        }
      })
    },

    async onConfig(row) {
      this.currentCabinetId = row.ID
      this.currentCabinetName = row.name
      this.configResult = null
      this.isConfigLoading = false
      this.visible.configDialog = true
      // 1. 调用接口获取已配置数据
      const configData = await this.getBranchBoxConfig(row.ID)
      if (configData && configData.data) {
        // 填充表单数据
        const data = configData.data
        this.configForm = configData.data
        this.configForm.triplet_id = row.triplet_id
      } else {
        // 如果没有配置数据，使用默认值
        this.configForm = this.getDefaultConfig()
      }
    },
    getDefaultConfig() {
      return {
        triphase_freq: 300,
        breaker_freq: 300,
        breaker_num: 0,
        trans_acap: 0,
        trans_bcap: 0,
        trans_ccap: 0,
        breaker_a: 60,
        breaker_b: 60,
        breaker_c: 60
      }
    },
    // 获取电柜配置
    async getBranchBoxConfig(id) {
      const params = {
        BranchBoxId: id
      }
      const response = await Get_BrandBox_ParamConfigById(params)
      return response
    },

    async onUpdate(row) {
      this.visible.editGroup = true
      this.isUpdate = true
      this.gid = row.ID

      // 确保一体柜数据已加载
      if (!this.cabinetOptions.length) {
        await this.loadCabinetOptions()
      }

      // 设置表单数据
      this.form.name = row.name
      this.form.power_cabinet_id = row.power_cabinet_id
      this.form.address = row.address
      this.form.remark = row.remark
      this.form.triplet_id = row.triplet_id
      this.form.assets_code = row.assets_code

      this.form.is_operation = row.is_operation
      this.form.costModel = row.costModel || ""
      this.form.costModelName = row.costModelName || ""

      if (row.pic_json) {
        try {
          if (row.pic_json.startsWith("[") || row.pic_json.startsWith("{")) {
            const picArray = JSON.parse(row.pic_json)
            if (Array.isArray(picArray)) {
              this.form.pic_json = picArray.map((item) => ({
                ...item,
                url: item.path,
                name: item.name || `image_${item.id || Date.now()}`,
                path: item.path,
                size: item.size || 0
              }))
            } else {
              this.form.pic_json = []
            }
          } else {
            const urls = row.pic_json
              .replace(/^,|,$/g, "")
              .split(",")
              .filter((url) => url.trim() !== "")
            this.form.pic_json = urls.map((url, index) => ({
              url: url.trim(),
              name: `image_${index + 1}`,
              path: url.trim(),
              size: 0
            }))
          }
        } catch (error) {
          const urls = row.pic_json
            .replace(/^,|,$/g, "")
            .split(",")
            .filter((url) => url.trim() !== "")
          this.form.pic_json = urls.map((url, index) => ({
            url: url.trim(),
            name: `image_${index + 1}`,
            path: url.trim(),
            size: 0
          }))
        }
      } else {
        this.form.pic_json = []
      }

    },

    fileChange(fileList, field) {
      this.uploadhandlerimgs = ""
      this.form[field] = fileList
      fileList.forEach((d) => {
        this.uploadhandlerimgs += d.url + ","
      })
    },

    onDelete(row) {
      this.$confirm("确定要删除此分支箱吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delPowerBranchBox(row).then((res) => {
            this.$message.success("删除成功")
            this.toFilter()
          })
        })
        .catch(() => {})
    },

    confirmSelectTriplet(item) {
      this.visible.triplet = false
      this.form.triplet_id = item.ID
      this.form.assets_code = item.assetsCode
    },

    onSelectTriplet() {
      if (this.isUpdate) {
        return
      }
      this.visible.triplet = true
    },

    getData() {
      this.loading = true
      getPowerBranchBoxList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        name: this.filter.name || null,
        is_operation: this.filter.is_operation || null,
        assets_code: this.filter.assets_code || null
      })
        .then((res) => {
          // 创建一体柜映射表
          const cabinetMap = {}
          this.cabinetOptions.forEach((cabinet) => {
            cabinetMap[cabinet.ID] = cabinet.name || cabinet.address || cabinet.ID
          })

          // 处理表格数据 - 添加一体柜名称字段用于显示
          this.tableData = res.data.map((item) => {
            return {
              ...item,
              cabinet_name: cabinetMap[item.power_cabinet_id] || item.power_cabinet_id,
              costModel: item.costModel || "",
              costModelName: item.costModelName || ""
            }
          })
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    onTongbuKc() {
      this.loading = true
      tongbuKcBranchBox()
        .then((res) => {
          if (res.num > 0) {
            this.$message.success(`同步三元${res.num}个`)
            this.getData()
          } else {
            this.$message.info(`同步三元${res.num}个`)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onAdd() {
      this.visible.editGroup = true
      this.isUpdate = false
      this.form = this.$options.data().form

      // 确保一体柜数据已加载
      if (!this.cabinetOptions.length) {
        await this.loadCabinetOptions()
      }
    },

    onSubmit() {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading()
          const reqData = {
            name: this.form.name,

            triplet_id: this.form.triplet_id,
            power_cabinet_id: this.form.power_cabinet_id,
            address: this.form.address,
            remark: this.form.remark,
            costModel: this.form.costModel,
            costModelName: this.form.costModelName,
            is_operation: this.form.is_operation,
            pic_json: this.uploadhandlerimgs
          }
          if (this.isUpdate) {
            reqData.ID = this.gid
            modifyPowerBranchBox(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.modifiedsuccessful")}`)
                this.visible.editGroup = false
                this.toFilter()
              })
              .finally(() => {
                loading.close()
              })
          } else {
            addPowerBranchBox(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.addedsuccessful")}`)
                this.visible.editGroup = false
                this.toFilter()
              })
              .finally(() => {
                loading.close()
              })
          }
        }
      })
    },

    // 验证频率
    validateFrequency(rule, value, callback) {
      if (value < 1 || value > 86400) {
        callback(new Error("频率必须在1-86400秒之间"))
      } else {
        callback()
      }
    },

    // 验证容量
    validateCapacity(rule, value, callback) {
      if (value < 0 || value > 10000) {
        callback(new Error("容量必须在0-10000kWA之间"))
      } else if (!Number.isInteger(value)) {
        callback(new Error("容量必须为整数"))
      } else {
        callback()
      }
    },

    getFirstImageUrl(picJsonString) {
      if (!picJsonString) return null

      try {
        if (picJsonString.startsWith("[") || picJsonString.startsWith("{")) {
          const picArray = JSON.parse(picJsonString)
          if (Array.isArray(picArray)) {
            const validPics = picArray.filter((pic) => pic.path && pic.path.trim() !== "")
            if (validPics.length > 0) {
              return validPics[0].path
            }
          }
        } else {
          const urls = picJsonString
            .replace(/^,|,$/g, "")
            .split(",")
            .filter((url) => url.trim() !== "")
          if (urls.length > 0) {
            return urls[0].trim()
          }
        }
        return null
      } catch (error) {
        const urls = picJsonString
          .replace(/^,|,$/g, "")
          .split(",")
          .filter((url) => url.trim() !== "")
        if (urls.length > 0) {
          return urls[0].trim()
        }
        return null
      }
    },

    getAllImageUrls(picJsonString) {
      if (!picJsonString) return []

      try {
        if (picJsonString.startsWith("[") || picJsonString.startsWith("{")) {
          const picArray = JSON.parse(picJsonString)
          if (Array.isArray(picArray)) {
            return picArray.filter((pic) => pic.path && pic.path.trim() !== "").map((pic) => pic.path)
          }
        } else {
          const urls = picJsonString
            .replace(/^,|,$/g, "")
            .split(",")
            .filter((url) => url.trim() !== "")
          return urls.map((url) => url.trim())
        }
        return []
      } catch (error) {
        const urls = picJsonString
          .replace(/^,|,$/g, "")
          .split(",")
          .filter((url) => url.trim() !== "")
        return urls.map((url) => url.trim())
      }
    },

  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}

.input-small {
  width: 200px;
}

.ml-10 {
  margin-left: 10px;
}
.custom-label {
  padding-left: 100px;
}
.temp-label {
  padding-left: 10px;
}
.custom-label /deep/.el-form-item__label {
  width: 80px !important; /* 或者其他你想要的宽度 */
}
.custom-label /deep/.el-form-item__content {
  margin-left: 80px !important; /* 或者其他你想要的宽度 */
}
.x_lab {
  line-height: 36px;
  font-weight: bold;
  margin-left: 5px;
}

.custom-label /deep/.el-form-item__error {
  min-width: 100px;
}

.table-img {
  width: 50px;
  height: 50px;
}
</style>
